import React from 'react';
import { Image } from 'gql/autogen/Image';
import 'component/common/ActivityCard/Image/ActivityCardImage.scss';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';

interface ActivityCardImageProps {
    index: number;
    image?: Image;
    isMobileScreen: boolean;
    onLoad?: () => void;
}

const ActivityCardImage: React.FC<ActivityCardImageProps> = React.memo(({ index, image, isMobileScreen, onLoad }) => {
    const onLoadLocal = React.useCallback(() => {
        if (typeof onLoad === 'function') onLoad();
    }, [onLoad]);

    if (!image) return null;

    return (
        <ActivityImage
            src={image.url || ''}
            alt={image.description || ''}
            title={image.description}
            objectFit="cover"
            borderRadius={isMobileScreen ? '16' : '0'}
            aspectRatio={isMobileScreen ? '1/1' : '5/3'}
            height={isMobileScreen ? '116px' : '100%'}
            width={isMobileScreen ? '116px' : '100%'}
            maxHeight="192px"
            onLoad={onLoadLocal}
            loading={index <= 2 ? 'immediate' : 'lazy'}
        />
    );
});
ActivityCardImage.displayName = 'ActivityCardImage';

export default ActivityCardImage;
